import styles from "./LoaderSVG.module.css";

interface LoaderSVGProps {
  primaryStroke: string;
  secondaryStroke: string;
  strokeWidth?: string | number;
  size?: number | string;
}

const LoaderSVG = ({
  primaryStroke,
  secondaryStroke,
  strokeWidth,
  size,
}: LoaderSVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="25 25 50 50"
      className={styles.circular}
      width={size}
      height={size}
    >
      <circle
        className={styles.pathOutline}
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth={strokeWidth ?? "2"}
        strokeMiterlimit="10"
        style={{ stroke: secondaryStroke }}
      />
      <circle
        className={styles.path}
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth={strokeWidth ?? "2"}
        strokeMiterlimit="10"
        style={{ stroke: primaryStroke }}
      />
    </svg>
  );
};

export default LoaderSVG;
